module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-fluted-balmoral-0.4934b75e.jpg";